import styled from '@emotion/styled';

const GetInTouchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  background: white;
  position: static;
  right: 24px;
  top: 130px;
  width: 100%;
  padding: 0;

  .header {
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile_landscape}) {
      display: flex;
    }

    .avatar {
      width: 116px;
      margin: 24px;

      @media (min-width: ${(props) => props.theme.breakpoints.mobile_landscape}) {
        margin: 30px;
      }
    }

    .title {
      text-align: center;
      line-height: 30px;
    }
  }

  .name {
    font-size: 18px;
    line-height: 30px;
    font-weight: bold;
  }

  .caption {
    font-size: 18px;
    line-height: 30px;
    color: ${(props) => props.theme.colors.grey._400};
  }

  .CTA {
    margin-top: 22px;
    padding: 0 1rem;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile_landscape}) {
      width: 322px;
    }
  }
`;

export { GetInTouchWrapper };
